import { atom } from 'jotai';
import { DEFAULT_CONFIG } from '../../models/data/ChatbotConfig';

export const chatbotConfigState = atom(DEFAULT_CONFIG);
export const configLoadingState = atom(true);